/**
 * Menu Configuration - Defines all available menus for different user roles
 */
export const MENU_ICONS = {
  INBOX: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  COMPLAINTS: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
  OFFICERS: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
  SETTINGS: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
  DOCUMENT: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  ADD: 'M12 6v6m0 0v6m0-6h6m-6 0H6',
  DASHBOARD: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  REPORTS: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
};

export const ROLES = {
  CVO: 'cvo',
  AUTHORITY: 'authority',
  OFFICER: 'officer',
  ADMIN: 'admin'
};

export const CVO_MENU = [
  {
    id: 'inbox',
    title: 'INBOX',
    icon: MENU_ICONS.INBOX,
    description: 'View all notification updates',
    path: '/cvo-dashboard',
    component: 'InboxView',
    requiresAuth: true,
    roles: [ROLES.CVO],
    featurePermission: 'inbox'
  },
  {
    id: 'complaints',
    title: 'All Complaints',
    icon: MENU_ICONS.COMPLAINTS,
    description: 'View and manage all complaints',
    path: '/cvo-dashboard',
    component: 'ComplaintsView',
    requiresAuth: true,
    roles: [ROLES.CVO],
    featurePermission: 'all-complaints'
  },
  {
    id: 'officers',
    title: 'Officers',
    icon: MENU_ICONS.OFFICERS,
    description: 'Manage complaint officers and assignments',
    path: '/cvo-dashboard',
    component: 'OfficersView',
    requiresAuth: true,
    roles: [ROLES.CVO],
    featurePermission: 'officers'
  },
  {
    id: 'cvos',
    title: 'CVOs',
    icon: MENU_ICONS.ADD,
    description: 'Manage CVO users and add new CVOs',
    path: '/cvo-dashboard',
    component: 'AddCVOView',
    requiresAuth: true,
    roles: [ROLES.CVO],
    featurePermission: 'cvos'
  },
  {
    id: 'settings',
    title: 'Settings',
    icon: MENU_ICONS.SETTINGS,
    description: 'Manage dropdown options and system settings',
    path: '/cvo-dashboard',
    component: 'SettingsView',
    requiresAuth: true,
    roles: [ROLES.CVO],
    featurePermission: 'settings'
  }
];

export const AUTHORITY_MENU = [
  {
    id: 'inbox',
    title: 'INBOX',
    icon: MENU_ICONS.INBOX,
    description: 'View all notification updates',
    path: '/authority-dashboard',
    component: 'InboxView',
    requiresAuth: true,
    roles: [ROLES.AUTHORITY],
    featurePermission: 'inbox'
  },
  {
    id: 'assigned-complaints',
    title: 'Assigned Complaints',
    icon: MENU_ICONS.DOCUMENT,
    description: 'Filter and edit complaints',
    path: '/authority-dashboard',
    component: 'AssignedComplaintsView',
    requiresAuth: true,
    roles: [ROLES.AUTHORITY],
    featurePermission: 'assigned-complaints'
  },
  {
    id: 'offline-complaints',
    title: 'Offline Complaints',
    icon: MENU_ICONS.DOCUMENT,
    description: 'View and manage offline complaints',
    path: '/authority-dashboard',
    component: 'OfflineComplaintsView',
    requiresAuth: true,
    roles: [ROLES.AUTHORITY],
    featurePermission: 'offline-complaints'
  },
  {
    id: 'officers',
    title: 'Officers',
    icon: MENU_ICONS.OFFICERS,
    description: 'Manage complaint officers and assignments',
    path: '/authority-dashboard',
    component: 'OfficersView',
    requiresAuth: true,
    roles: [ROLES.AUTHORITY],
    featurePermission: 'officers'
  }
];

export const OFFICER_MENU = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: MENU_ICONS.DASHBOARD,
    description: 'View assigned complaints and tasks',
    path: '/officer-dashboard',
    component: 'OfficerDashboardView',
    requiresAuth: true,
    roles: [ROLES.OFFICER],
    featurePermission: 'dashboard'
  },
  {
    id: 'my-cases',
    title: 'My Cases',
    icon: MENU_ICONS.COMPLAINTS,
    description: 'Manage assigned cases',
    path: '/officer-dashboard',
    component: 'MyCasesView',
    requiresAuth: true,
    roles: [ROLES.OFFICER],
    featurePermission: 'my-cases'
  },
  {
    id: 'reports',
    title: 'Reports',
    icon: MENU_ICONS.REPORTS,
    description: 'Submit investigation reports',
    path: '/officer-dashboard',
    component: 'ReportsView',
    requiresAuth: true,
    roles: [ROLES.OFFICER],
    featurePermission: 'reports'
  }
];

/**
 * Get menu items based on user role
 * @param {string} role - User role (cvo, authority, officer, etc.)
 * @returns {Array} Array of menu items for the specified role
 */
export const getMenuByRole = (role) => {
  if (!role) return [];
  
  const normalizedRole = role.toLowerCase();
  
  switch (normalizedRole) {
    case ROLES.CVO:
      return CVO_MENU;
    case ROLES.AUTHORITY:
      return AUTHORITY_MENU;
    case ROLES.OFFICER:
      return OFFICER_MENU;
    default:
      console.warn(`Unknown role: ${role}`);
      return [];
  }
};

/**
 * Check if user has access to a specific menu item
 * @param {Object} menuItem - Menu item to check
 * @param {string} userRole - User's role
 * @returns {boolean} True if user has access
 */
export const hasMenuAccess = (menuItem, userRole) => {
  if (!menuItem || !userRole) return false;
  
  return menuItem.roles.includes(userRole.toLowerCase());
};

/**
 * Get menu item by ID
 * @param {string} menuId - Menu item ID
 * @param {string} role - User role
 * @returns {Object|null} Menu item object or null if not found
 */
export const getMenuItemById = (menuId, role) => {
  const menu = getMenuByRole(role);
  return menu.find(item => item.id === menuId) || null;
};

export const getDefaultMenuItem = (role) => {
  const menu = getMenuByRole(role);
  return menu.length > 0 ? menu[0] : null;
};


export default {
  MENU_ICONS,
  ROLES,
  CVO_MENU,
  AUTHORITY_MENU,
  OFFICER_MENU,
  getMenuByRole,
  hasMenuAccess,
  getMenuItemById,
  getDefaultMenuItem
};

